export default __webpack_public_path__ + "static/media/Rule2.5074a0bc.png";